import React from "react";
import { COLORS } from "./constants";

export function glow(c: string, strong = false): string {
  return strong
    ? `0 0 24px ${c}cc, 0 0 60px ${c}77, 0 0 120px ${c}33`
    : `0 0 16px ${c}99, 0 0 40px ${c}44`;
}

export const Backdrop: React.FC<{ frame: number; accent: string }> = ({ frame, accent }) => {
  const drift = Math.sin(frame * 0.005) * 6;
  return (
    <>
      <div style={{
        position: "absolute", inset: 0,
        background: `radial-gradient(ellipse 80% 60% at 50% 50%, ${accent}10 0%, transparent 70%)`,
      }} />
      <div style={{
        position: "absolute", inset: 0,
        backgroundImage: `linear-gradient(${accent}0a 1px, transparent 1px), linear-gradient(90deg, ${accent}0a 1px, transparent 1px)`,
        backgroundSize: "80px 80px",
        transform: `translateY(${drift}px)`,
      }} />
      {[
        { x: 200, y: 220, s: 500, c: accent, sp: 0.005 },
        { x: 1680, y: 340, s: 440, c: COLORS.neonPurple, sp: 0.004 },
        { x: 960, y: 880, s: 600, c: COLORS.neonBlue, sp: 0.003 },
      ].map((o, i) => (
        <div key={i} style={{
          position: "absolute",
          left: o.x + Math.sin(frame * o.sp + i) * 30 - o.s / 2,
          top: o.y + Math.cos(frame * o.sp * 0.7 + i) * 20 - o.s / 2,
          width: o.s, height: o.s,
          borderRadius: "50%",
          background: `radial-gradient(circle, ${o.c}08 0%, transparent 70%)`,
          pointerEvents: "none",
        }} />
      ))}
      {[...Array(12)].map((_, i) => {
        const px = 100 + ((i * 157) % 1800);
        const py = 60 + ((i * 97) % 960);
        const colors = [COLORS.neonPink, COLORS.neonBlue, COLORS.neonGreen, COLORS.neonCyan, COLORS.neonPurple, COLORS.neonYellow];
        const c = colors[i % colors.length];
        return (
          <div key={`p-${i}`} style={{
            position: "absolute",
            left: px + Math.sin(frame * 0.02 + i * 1.3) * 18,
            top: py + Math.cos(frame * 0.015 + i * 1.7) * 14,
            width: 4, height: 4,
            borderRadius: "50%",
            background: c,
            boxShadow: `0 0 12px ${c}, 0 0 24px ${c}66`,
            opacity: 0.55,
            pointerEvents: "none",
          }} />
        );
      })}
    </>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
